import React, { Component } from 'react'
import OneLineEditor from '../../../components/OneLineEditor'
import EstimationStore from '../../../libs/EstimationStore'
import EstimationActions from '../../../libs/EstimationActions'
import Utils from '../../../libs/Utils'

class MaterialCostTab extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: EstimationActions.getCurrentEstimation(),
      listener: null
    }
  }
  componentDidMount () {
    this.setState({
      listener: EstimationStore.addListener('change', () => {
        this.setState({
          data: EstimationActions.getCurrentEstimation()
        })
      })
    })
  }
  componentWillUnmount () {
    if (this.state.listener) this.state.listener.remove()
  }

  render () {
    var uchiwakeMokuzaiList = []
    var uchiwakeShoumouhinList = []
    var uchiwakeKouseizaiList = []
    var data = this.state.data.uchiwakeList
    let mokuzaiGoukei = 0
    let shoumouhinGoukei = 0
    let kousezaiGoukei = 0
    let katawakuSuuryou = 0
    for (let i = 0; i < data.length; i++) {
      if (data[i].isKatawakuSuuryou) {
        katawakuSuuryou += data[i].suuryou ? parseFloat(data[i].suuryou) : 0
      }
      mokuzaiGoukei += Math.round(data[i].materialMokuzaiUnitPrice * data[i].suuryou)
      const kwDoubble = (i === 0) ? 'kw-top-double ' : ''
      const kwLast = (i === data.length - 1) ? 'kw-bottom-double ' : ''
      uchiwakeMokuzaiList.push(
        <tr style={{borderTop: (i === 0) ? '3px double black' : ''}} key={i}>
          <td className={kwDoubble + kwLast + 'kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='name' viewListId='uchiwakeMokuzaiList' /></td>
          <td className={kwDoubble + kwLast + 'text-right kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='suuryou' isNum textAlign='right' decimalPlaces='1' viewListId='uchiwakeMokuzaiList' /></td>
          <td className={kwDoubble + kwLast + 'text-center kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='tani' viewListId='uchiwakeMokuzaiList' /></td>
          <td className={kwDoubble + kwLast + 'text-right kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='materialMokuzaiUnitPrice' isCommaSeparated isNum prefix='¥' decimalPlaces='1' textAlign='right' viewListId='uchiwakeMokuzaiList' /></td>
          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku(data[i].suuryou * data[i].materialMokuzaiUnitPrice)}</td>
          <td className={kwDoubble + kwLast + 'kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='meterialMokuzaiNote' viewListId='uchiwakeMokuzaiList' /></td>
        </tr>
      )
      shoumouhinGoukei += Math.round(data[i].materialShoumouhinUnitPrice * data[i].suuryou)
      uchiwakeShoumouhinList.push(
        <tr style={{borderTop: (i === 0) ? '3px double black' : ''}} key={i}>
          <td className={kwDoubble + kwLast + 'kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='name' viewListId='uchiwakeShoumouhinList' /></td>
          <td className={kwDoubble + kwLast + 'text-right kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='suuryou' isNum textAlign='right' decimalPlaces='1' viewListId='uchiwakeShoumouhinList' /></td>
          <td className={kwDoubble + kwLast + 'text-center kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='tani' viewListId='uchiwakeShoumouhinList' /></td>
          <td className={kwDoubble + kwLast + 'text-right kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='materialShoumouhinUnitPrice' isCommaSeparated isNum prefix='¥' decimalPlaces='1' textAlign='right' viewListId='uchiwakeShoumouhinList' /></td>
          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku(data[i].suuryou * data[i].materialShoumouhinUnitPrice)}</td>
          <td className={kwDoubble + kwLast + 'kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='meterialShoumouhinNote' viewListId='uchiwakeShoumouhinList' /></td>
        </tr>
      )
      kousezaiGoukei += Math.round(data[i].materialKouseizaiUnitPrice * data[i].suuryou)
      uchiwakeKouseizaiList.push(
        <tr style={{borderTop: (i === 0) ? '3px double black' : ''}} key={i}>
          <td className={kwDoubble + kwLast + 'kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='name' viewListId='uchiwakeKouseizaiList' /></td>
          <td className={kwDoubble + kwLast + 'text-right kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='suuryou' isNum textAlign='right' decimalPlaces='1' viewListId='uchiwakeKouseizaiList' /></td>
          <td className={kwDoubble + kwLast + 'text-center kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='tani' viewListId='uchiwakeKouseizaiList' /></td>
          <td className={kwDoubble + kwLast + 'text-right kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='materialKouseizaiUnitPrice' textAlign='right' isCommaSeparated isNum prefix='¥' decimalPlaces='1' viewListId='uchiwakeKouseizaiList' /></td>
          <td className={kwDoubble + kwLast + 'text-right'}>{Utils.convKingaku(data[i].suuryou * data[i].materialKouseizaiUnitPrice)}</td>
          <td className={kwDoubble + kwLast + 'kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='meterialKouseizaiNote' viewListId='uchiwakeKouseizaiList' /></td>
        </tr>
      )
    }

    if (!this.state.data.materialCostDetailInputMode) {
      mokuzaiGoukei = this.state.data.materialMokuzaiUnitPrice * katawakuSuuryou
      shoumouhinGoukei = this.state.data.materialShoumouhinUnitPrice * katawakuSuuryou
      kousezaiGoukei = this.state.data.materialKouseizaiUnitPrice * katawakuSuuryou
    }
    const inputStyle = {
      backgroundColor: !this.state.data.materialCostDetailInputMode ? '#ffffe0' : 'FFFFFF',
      cursor: !this.state.data.materialCostDetailInputMode ? 'pointer' : 'normal'
    }
    return (
      <div style={{marginBottom: '10px'}}>
        <article className='kw-katawaku-art'>
          <div className='kw-materialview'>
            <div className='kw-detail'>
              <p className='kw-pad1 kw-clear'>材料費計</p>

              <table>
                <thead>
                  <tr>
                    <th className='kw-name' />
                    <th className='kw-person' />
                    <th className='kw-unit' />
                    <th className='kw-yen-unit-price' />
                    <th className='kw-yen1' />
                    <th className='kw-note' />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>名称</th>
                    <th>数量</th>
                    <th>単位</th>
                    <th>単価</th>
                    <th>金額</th>
                    <th>備考</th>
                  </tr>
                  <tr>
                    <td className='kw-top-double'>木材費</td>
                    <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou, 1)}</td>
                    <td className='kw-top-double text-center'>㎡</td>
                    <td className='kw-top-double text-right' style={inputStyle}>
                      {this.state.data.materialCostDetailInputMode
                      ? Utils.convKingaku(mokuzaiGoukei / katawakuSuuryou, 1)
                      : <OneLineEditor bindingDataAttribute='materialMokuzaiUnitPrice' textAlign='right' prefix='¥' isCommaSeparated />
                    }
                    </td>
                    <td className='kw-top-double text-right'>{Utils.convKingaku(mokuzaiGoukei)}</td>
                    <td className='kw-top-double kw-inputable'><OneLineEditor bindingDataAttribute='materialMokuzaiNote' /></td>
                  </tr>
                  <tr>
                    <td>消耗品費</td>
                    <td className='text-right'>{Utils.convSuuryou(katawakuSuuryou, 1)}</td>
                    <td className='text-center'>㎡</td>
                    <td className='text-right' style={inputStyle}>
                      {this.state.data.materialCostDetailInputMode
                      ? Utils.convKingaku(shoumouhinGoukei / katawakuSuuryou, 1)
                      : <OneLineEditor bindingDataAttribute='materialShoumouhinUnitPrice' textAlign='right' prefix='¥' isCommaSeparated />
                    }
                    </td>
                    <td className='text-right'>{Utils.convKingaku(shoumouhinGoukei)}</td>
                    <td className='kw-inputable'><OneLineEditor bindingDataAttribute='materialShoumouhinNote' /></td>
                  </tr>
                  <tr>
                    <td className='kw-bottom-double'>鋼製材損料</td>
                    <td className='kw-bottom-double text-right'>{Utils.convSuuryou(katawakuSuuryou, 1)}</td>
                    <td className='kw-bottom-double text-center'>㎡</td>
                    <td className='kw-bottom-double text-right' style={inputStyle}>
                      {this.state.data.materialCostDetailInputMode
                                          ? Utils.convKingaku(kousezaiGoukei / katawakuSuuryou, 1)
                                          : <OneLineEditor bindingDataAttribute='materialKouseizaiUnitPrice' textAlign='right' prefix='¥' isCommaSeparated />
                                        }</td>
                    <td className='kw-bottom-double text-right'>
                      {Utils.convKingaku(kousezaiGoukei)}
                    </td>
                    <td className='kw-bottom-double kw-inputable'><OneLineEditor bindingDataAttribute='materialKouseizaiNote' /></td>
                  </tr>
                  <tr>
                    <td className='kw-top-double'>合計</td>
                    <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou, 1)}</td>
                    <td className='kw-top-double kw-ln' />
                    <td className='kw-top-double text-right'>{Utils.convKingaku((mokuzaiGoukei + shoumouhinGoukei + kousezaiGoukei) / katawakuSuuryou, 1)}</td>
                    <td className='kw-top-double text-right'>{Utils.convKingaku(mokuzaiGoukei + shoumouhinGoukei + kousezaiGoukei)}</td>
                    <td className='kw-top-double' />
                  </tr>
                </tbody>
              </table>

            </div>{/* <!-- .kw-detail --> */}
            <br />
            {this.state.data.materialCostDetailInputMode
  ? <div>
    {/* 木材費 start */}
    <div className='kw-detail'>
      <p className='kw-pad1 kw-clear'>木材費</p>

      <table>
        <thead>
          <tr>
            <th className='kw-name' />
            <th className='kw-person' />
            <th className='kw-unit' />
            <th className='kw-yen-unit-price' />
            <th className='kw-yen1' />
            <th className='kw-note' />
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>名称</th>
            <th>数量</th>
            <th>単位</th>
            <th>単価</th>
            <th>金額</th>
            <th>備考</th>
          </tr>
          {uchiwakeMokuzaiList}
          <tr>
            <td className='kw-top-double'>小計</td>
            <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
            <td className='kw-top-double kw-ln' />
            <td className='kw-top-double text-right'>{Utils.convKingaku(mokuzaiGoukei / katawakuSuuryou, 1)}</td>
            <td className='kw-top-double text-right'>{Utils.convKingaku(mokuzaiGoukei)}</td>
            <td className='kw-top-double' />
          </tr>
        </tbody>
      </table>
    </div>
    {/* 木材費 end */}

    {/* 消耗品費 start */}
    <div className='kw-detail'>
      <p className='kw-pad1 kw-clear'>消耗品費</p>

      <table>
        <thead>
          <tr>
            <th className='kw-name' />
            <th className='kw-person' />
            <th className='kw-unit' />
            <th className='kw-yen-unit-price' />
            <th className='kw-yen1' />
            <th className='kw-note' />
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>名称</th>
            <th>数量</th>
            <th>単位</th>
            <th>単価</th>
            <th>金額</th>
            <th>備考</th>
          </tr>
          {uchiwakeShoumouhinList}
          <tr>
            <td className='kw-top-double'>小計</td>
            <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
            <td className='kw-top-double kw-ln' />
            <td className='kw-top-double text-right'>{Utils.convKingaku(shoumouhinGoukei / katawakuSuuryou, 1)}</td>
            <td className='kw-top-double text-right'>{Utils.convKingaku(shoumouhinGoukei)}</td>
            <td className='kw-top-double' />
          </tr>
        </tbody>
      </table>
    </div>
    {/* 消耗品費 end */}

    {/* 鋼製材損料 start */}
    <div className='kw-detail'>
      <p className='kw-pad1 kw-clear'>鋼製材損料</p>

      <table>
        <thead>
          <tr>
            <th className='kw-name' />
            <th className='kw-person' />
            <th className='kw-unit' />
            <th className='kw-yen-unit-price' />
            <th className='kw-yen1' />
            <th className='kw-note' />
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>名称</th>
            <th>数量</th>
            <th>単位</th>
            <th>単価</th>
            <th>金額</th>
            <th>備考</th>
          </tr>
          {uchiwakeKouseizaiList}
          <tr>
            <td className='kw-top-double'>小計</td>
            <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
            <td className='kw-top-double kw-ln' />
            <td className='kw-top-double text-right'>{Utils.convKingaku(kousezaiGoukei / katawakuSuuryou, 1)}</td>
            <td className='kw-top-double text-right'>{Utils.convKingaku(kousezaiGoukei)}</td>
            <td className='kw-top-double' />
          </tr>
        </tbody>
      </table>
    </div>
    {/* 鋼製材損料 end */}
  </div>

: ''}

          </div>{/* <!-- .kw-materialview --> */}
          {/* </div> */}{/* <!-- .kw-container --> */}
          {/* </section> */}
        </article>
      </div>
    )
  }
}

export default MaterialCostTab



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationEdit/MaterialCostTab.js